module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag11_0513AT.608d3b05.jpg";